import Svg, { Path } from 'react-native-svg'

export const ItemChecked = ({ height = 16, width = 16, color = '#00B259' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M8 1.334a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.334Zm3.473 5.14-4 4a.666.666 0 0 1-.946 0l-2-2a.67.67 0 1 1 .946-.947L7 9.061l3.527-3.534a.67.67 0 1 1 .946.947Z"
      />
    </Svg>
  )
}
